import React from 'react';

const GD = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_149"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_149)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#D0091E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3H18V12H3V3Z"
        fill="#FDD200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3L10.5 7.5L3 12V3Z"
        fill="#007B5D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 7H5V8H4V7Z"
        fill="#F7BA03"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3L10.5 7.5L18 12V3Z"
        fill="#007B5D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 1H8V2H7V1ZM10 1H11V2H10V1ZM13 1H14V2H13V1ZM7 13H8V14H7V13ZM10 13H11V14H10V13ZM13 13H14V14H13V13Z"
        fill="#F3A906"
      />
      <path
        d="M10.5 10C11.8807 10 13 8.88071 13 7.5C13 6.11929 11.8807 5 10.5 5C9.11929 5 8 6.11929 8 7.5C8 8.88071 9.11929 10 10.5 10Z"
        fill="#D0091E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 8.75L9.03001 9.523L9.31001 7.886L8.12201 6.726L9.76501 6.489L10.5 5L11.235 6.49L12.878 6.727L11.688 7.887L11.968 9.523"
        fill="#FDD200"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default GD;
